<template>

  <div class="flex-grow">
    <div v-show="!detail" class="fixed h-screen w-full bg-white bg-opacity-90 z-50 flex justify-center items-center"> 
      <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-theme-sky"></div>
    </div>
    <div class="bg-theme-light">
      <div class="section container px-6 pt-20 pb-10 mx-auto flex justify-center items-baseline">
        <div class="hidden md:block md:w-1/4"></div>
        <div class="w-4/4 md:w-2/4 md:ml-10 flex flex-col">
              <h1 class="text-5xl text-gray-900 capitalize">{{this.detail.name}} 
                <span class="text-theme-blue text-5xl font-semibold">{{this.detail.lastname}}</span> </h1>
              <h2 v-if="this.detail.type == 'ilustrador'" class="text-3xl text-theme-sky font-bold uppercase mt-2">Ilustrador</h2>
              <h2 v-if="this.detail.type == 'ilustradora'" class="text-3xl text-theme-sky font-bold uppercase mt-2">Ilustradora</h2>
              <h2 v-if="this.detail.type == 'escritora'" class="text-3xl text-theme-blue font-bold uppercase mt-2">Escritora</h2>
              <h2 v-if="this.detail.type == 'escritor'" class="text-3xl text-theme-blue font-bold uppercase mt-2">Escritor</h2>
        </div>
      </div>
    </div> 
    <div class="section container mx-auto flex flex-col md:flex-row items-center md:items-start justify-center mt-10">
      <img class="w-3/4 md:w-1/4 rounded-xl mb-5" :src="baseUrl + this.detail.image" alt="">
      <div class="w-3/4 md:w-2/4 md:ml-10 flex flex-col ">
        <div class="flex flex-wrap">

          <div v-show="this.detail.email" class="bg-theme-light m-2 rounded-xl flex hover:bg-bluegray-200">
            <a class="flex" :href="`mailto:${this.detail.email}`" target="_blank">
              <div class="col-span-1 w-12 flex justify-center items-center mx-auto bg-theme-sky rounded-l-xl text-white" >
                <Icons class="w-6 h-6  m-2 text-white" name="envelope"></Icons>
              </div>
              <div class="text-left flex items-center ml-2 mr-3 break-all">{{this.detail.email}}</div>
            </a>
          </div>

          <div v-show="this.detail.facebook" class="bg-theme-light m-2 rounded-xl flex hover:bg-bluegray-200">
            <a class="flex" :href="`https://www.facebook.com/${this.detail.facebook}`" target="_blank">
              <div class="col-span-1 w-12 flex justify-center items-center mx-auto bg-theme-sky rounded-l-xl text-white" >
                <Icons class="w-6 h-6  m-2 text-white fill-current" name="facebook"></Icons></div>
              <div class="text-left flex items-center ml-2 mr-3 break-all">{{this.detail.facebook}}</div>
            </a>
          </div>

          <div v-show="this.detail.instagram" class="bg-theme-light m-2 rounded-xl flex hover:bg-bluegray-200">
            <a class="flex" :href="`https://www.instagram.com/${this.detail.instagram}`" target="_blank">
              <div class="col-span-1 w-12 flex justify-center items-center mx-auto bg-theme-sky rounded-l-xl text-white" >
                <Icons class="w-6 h-6  m-2 text-white fill-current" name="instagram"></Icons></div>
              <div class="text-left flex items-center ml-2 mr-3 break-all">{{this.detail.instagram}}</div>
            </a>              
          </div>

          <div v-show="this.detail.twitter" class="bg-theme-light m-2 rounded-xl flex hover:bg-bluegray-200">
            <a class="flex" :href="`https://www.twitter.com/${this.detail.twitter}`" target="_blank">
              <div class="col-span-1 w-12 flex justify-center items-center mx-auto bg-theme-sky rounded-l-xl text-white" >
                <Icons class="w-6 h-6  m-2 text-white fill-current" name="twitter"></Icons></div>
              <div class="text-left flex items-center ml-2 mr-3 break-all">{{this.detail.twitter}}</div>
            </a>
          </div>

          <div v-show="this.detail.youtube" class="bg-theme-light m-2 rounded-xl flex hover:bg-bluegray-200">
            <a class="flex" :href="`https://www.youtube.com/${this.detail.youtube}`" target="_blank">
              <div class="col-span-1 w-12 flex justify-center items-center mx-auto bg-theme-sky rounded-l-xl text-white" >
                <Icons class="w-6 h-6  m-2 text-white fill-current" name="youtube"></Icons></div>
              <div class="text-left flex items-center ml-2 mr-3 break-all">{{this.detail.youtube}}</div>
            </a>              
          </div>

          <div v-show="this.detail.link" class="bg-theme-light m-2 rounded-xl flex hover:bg-bluegray-200">
            <a class="flex" :href="`https://${this.detail.link}`" target="_blank">
              <div class="col-span-1 w-12 flex justify-center items-center mx-auto bg-theme-sky rounded-l-xl text-white" >
                <Icons class="w-6 h-6  m-2 text-white" name="link"></Icons></div>
              <div class="text-left flex items-center ml-2 mr-3 break-all">{{this.detail.link}}</div>
            </a>              
          </div>

          <div v-show="this.detail.pinterest" class="bg-theme-light m-2 rounded-xl flex hover:bg-bluegray-200">
            <a class="flex" :href="`https://www.pinterest.com/${this.detail.pinterest}`" target="_blank">
              <div class="col-span-1 w-12 flex justify-center items-center mx-auto bg-theme-sky rounded-l-xl text-white" >
                <Icons class="w-6 h-6  m-2 text-white fill-current" name="pinterest"></Icons></div>
              <div class="text-left flex items-center ml-2 mr-3 break-all">{{this.detail.pinterest}}</div>
            </a>              
          </div>
      </div>
      </div>
    </div>

    <div v-show="this.detail.biography" class="section container mx-auto my-10 md:my-20 flex flex-col md:flex-row justify-center ">
      <div class="w-3/4 md:w-1/4 ml-10 text-theme-blue font-semibold text-3xl">BIOGRAFIA</div>
      <div class="w-3/4 md:w-2/4 ml-10 flex flex-col biography" v-html="this.detail.biography"></div>
    </div>

    <div v-show="this.detail.publishing" class="section container mx-auto my-10 md:my-20 flex flex-col md:flex-row justify-center">
      <div class="w-3/4 md:w-1/4 ml-10 text-theme-blue font-semibold text-3xl">PUBLICACIONES</div>
      <div class="w-3/4 md:w-2/4 ml-10 flex flex-col" v-html="this.detail.publishing"></div>
    </div>    

   
    <div class="section container flex w-3/4 mx-auto">
      <div  @click="goBack" class="cursor-pointer bg-theme-sky text-white text-sm rounded-lg py-2 px-4 flex items-center justify-start hover:bg-theme-blue">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 " fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        VOLVER</div>
   </div>


  </div> 

</template>

<script>
    import Icons from '@/components/Icons.vue'  

export default {
  name: "AutorDetail",
  props:['id'],     
  components: {
    Icons
  },

  data(){
      return{
        idAuthor: this.$props.id,
        //authors:"",
        baseUrl: process.env.VUE_APP_URL_CULTURAPP + 'storage/',
        detail:""
      }
  },
  methods: {
    // async getAuthors(){
    //   var get = `http://10.211.55.3:8005/api/authors`;
    //   const response = await fetch(get,{method: 'GET'})
    //   this.books = await response.json()
    //   // this.slides = this.libraries
    // }
    async getAuthorDetail(){
      var filter = `?id=${this.$props.id}`
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/authors${filter}`
      const response = await fetch(get,{method: 'GET'})
      this.detail = await response.json()
    },
    goBack(){
      this.$router.go(-1)
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },  
  created(){
    this.getAuthorDetail()
    // this.getAuthors()
  }
};
</script>

<style>
.biography p{
  padding-bottom: 1em;
}
.biography ul{
    margin:1em 0px;
    padding-left: 4vw;
}
.biography li{
      list-style: disc;
      padding-bottom: 0.5rem;
}
</style>